<div class="bn-event-logs-row-detail">
  <div class="bn-event-logs-row-detail__left">
    <div class="bn-event-logs-row-detail__headers">
      <span class="bn-event-logs-row-detail__label">Request headers</span>
      @if (log().Headers?.length) {
        <ul class="bn-event-logs-row-detail__headers-list">
          @for (header of log().Headers; track $index) {
            <li class="bn-event-logs-row-detail__header">
              <span class="bn-event-logs-row-detail__header-name">{{ header.Name }}:</span>
              <span class="bn-event-logs-row-detail__mono">{{ header.Value }}</span>
            </li>
          }
        </ul>
      } @else {
        <span class="bn-event-logs-row-detail__muted">No headers</span>
      }
    </div>

    @if (isWafRule() && ruleId(); as ruleId) {
      <bn-web-ui-alert
        alertType="warning"
        class="bn-event-logs-row-detail__actions"
        headerIcon="bolt"
        heading="Response action">
        <p class="bn-event-logs-row-detail__actions-text">
          Globally change how this rule responds. Affects every request matching rule
          <span class="bn-event-logs-row-detail__mono">{{ ruleId }}</span>
          on this zone - not just this client.
        </p>
        <div class="bn-event-logs-row-detail__actions-buttons">
          @if (isRuleBlocking()) {
            <button
              bn-web-ui-button
              data-e2e="EventLogDetailLogOnlyRuleButton"
              itemStyle="stroke"
              leftIcon="eye"
              (click)="logOnlyRule()">
              Make rule log only
            </button>
          } @else {
            <button
              bn-web-ui-button
              data-e2e="EventLogDetailEnableRuleButton"
              itemStyle="stroke"
              leftIcon="eye"
              (click)="enableRule()">
              Enable rule
            </button>
          }
          <button
            bn-web-ui-button
            data-e2e="EventLogDetailDisableRuleButton"
            itemStyle="stroke"
            leftIcon="ban"
            (click)="disableRule()">
            Disable rule
          </button>
        </div>
      </bn-web-ui-alert>
    }
  </div>

  <div class="bn-event-logs-row-detail__request">
    <div class="bn-event-logs-row-detail__field">
      <span class="bn-event-logs-row-detail__label">Method</span>
      @if (fields()['method']; as method) {
        <bn-web-ui-badge
          class="bn-event-logs-row-detail__method"
          contentClass="text-uppercase"
          size="sm"
          type="tag"
          [color]="methodColor(method) === 'light' ? '' : methodColor(method)"
          >{{ method }}</bn-web-ui-badge
        >
      } @else {
        <span class="bn-event-logs-row-detail__muted">—</span>
      }
    </div>

    <div class="bn-event-logs-row-detail__field">
      <span class="bn-event-logs-row-detail__label">URL</span>
      @if (safeUrl(); as href) {
        <a
          bn-web-ui-button
          class="bn-event-logs-row-detail__url"
          data-e2e="EventLogDetailUrlLink"
          itemStyle="stroke-blue"
          rel="noopener noreferrer"
          target="_blank"
          [href]="href"
          [lessPadding]="true"
          [rightIcon]="['fad', 'arrow-up-right-from-square']"
          >{{ url() }}</a
        >
      } @else if (url()) {
        <span class="bn-event-logs-row-detail__mono">{{ url() }}</span>
      } @else {
        <span class="bn-event-logs-row-detail__muted">—</span>
      }
    </div>

    <div class="bn-event-logs-row-detail__field">
      <span class="bn-event-logs-row-detail__label">Remote country</span>
      <bn-web-ui-flag
        class="d-inline-block"
        [countryCode]="fields()['country']"
        [displayCountryName]="true"
        [showTooltip]="false" />
    </div>

    <div class="bn-event-logs-row-detail__field">
      <span class="bn-event-logs-row-detail__label">ASN</span>
      @if (fields()['asn']) {
        <a
          bn-web-ui-button
          class="bn-event-logs-row-detail__asn"
          data-e2e="EventLogDetailAsnLink"
          href="https://ipinfo.io/AS{{ fields()['asn'] }}"
          itemStyle="stroke-blue"
          target="_blank"
          [lessPadding]="true"
          [rightIcon]="['fad', 'arrow-up-right-from-square']"
          >AS{{ fields()['asn'] }}</a
        >
      } @else {
        <span class="bn-event-logs-row-detail__muted">—</span>
      }
    </div>

    <div class="bn-event-logs-row-detail__field">
      <span class="bn-event-logs-row-detail__label">JA4 fingerprint</span>
      @if (fields()['ja4']) {
        <span class="bn-event-logs-row-detail__ja4">
          <span class="bn-event-logs-row-detail__mono">{{ fields()['ja4'] }}</span>
          <button
            bn-web-ui-button
            data-e2e="EventLogDetailCopyJa4Button"
            itemStyle="invisible"
            [isSquare]="true"
            (click)="copyJa4()">
            <fa-icon icon="copy" />
          </button>
        </span>
      } @else {
        <span class="bn-event-logs-row-detail__muted">—</span>
      }
    </div>

    <div class="bn-event-logs-row-detail__field">
      <span class="bn-event-logs-row-detail__label">User-Agent</span>
      <span class="bn-event-logs-row-detail__mono">{{ fields()['ua'] || '—' }}</span>
    </div>

    <div class="bn-event-logs-row-detail__field">
      <span class="bn-event-logs-row-detail__label">Request body</span>
      @if (log().UrlEncodedBody) {
        <pre class="bn-event-logs-row-detail__body"><code language="json" [highlight]="log().UrlEncodedBody ?? ''"></code></pre>
      } @else {
        <bn-web-ui-badge
          class="bn-event-logs-row-detail__no-body"
          color="blue"
          size="sm"
          type="tag"
          >No request body</bn-web-ui-badge
        >
      }
    </div>
  </div>
</div>
